import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level1: LevelConfig = {
  grid: [
    padRow(
      [
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue' } },
        'SW',
        null,
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'gold' } },
        'SW',
      ],
      'prepend',
      false,
    ),
    padRow(
      [
        'WE',
        { track: 'WE', vehicle: 'locomotive' },
        'WE',
        { track: ['WE', 'NE'] },
        'WE',
        { track: ['WE', 'SE'] },
        'WE',
        { track: ['WE', 'NE'] },
        'WE',
        { track: 'WE', exit: 'E' },
      ],
      'fill',
      true,
      9,
    ),
    padRow(
      [
        null,
        null,
        null,
        null,
        { track: 'NS', vehicle: { type: 'wagon', color: 'green', direction: -1 } },
      ],
      'prepend',
      false,
    ),
    padRow([null, null, null, null, 'S'], 'prepend', false),
  ],
  goal: { sequence: ['blue', 'green', 'gold'] },
}
